import axiosInstance from "./AxiosInstance"

export function getVendorListApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/vendors?${fparam}`)
}

export function createVendorApi(data){
    return axiosInstance.post('api/vendors',data)
}

export function updateVendorApi(id,data){
    return axiosInstance.put(`api/vendors/${id}`,data)
}

export function deleteVendorApi(id){
    return axiosInstance.delete(`api/vendors/${id}`)
}